import { startOfWeek, endOfDay, startOfDay, eachDayOfInterval } from 'date-fns';

/** Monday-start calendar week from week start through today (inclusive). */
export const getCurrentWeekRange = (referenceDate = new Date()) => {
  const endDate = endOfDay(referenceDate);
  const startDate = startOfDay(startOfWeek(referenceDate, { weekStartsOn: 1 }));
  const days = eachDayOfInterval({ start: startDate, end: endDate });

  return { startDate, endDate, days, dayCount: days.length };
};
